import React from "react";
import Lotties from "react-lottie";
import animationData from "../../assets/lottie/login/data.json";
import "../../assets/styles/auth/login.scss";

import {styled} from "@mui/material";

const LottiesWrapper = styled("div")(({theme}) => ({
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));

export default function Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    return (
        <LottiesWrapper className="wrap-lottie-cm">
            <Lotties options={defaultOptions} height={100 + "%"} width={100 + "%"}/>
        </LottiesWrapper>
    );
}
